import { Outlet } from 'react-router-dom';
import FowBrand from '@components/common/FowBrand';

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-100 to-primary-200 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary-600">
            <FowBrand />
          </h1>
          <p className="text-primary-700 mt-2">
            Your journey to success starts here
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <Outlet />
        </div>
        
        <div className="text-center mt-6 text-sm text-primary-600">
          &copy; {new Date().getFullYear()} F.O.W. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
